var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5588 13.1987C14.0827 13.3733 14.649 13.0902 14.8237 12.5662C14.9983 12.0423 14.7152 11.476 14.1912 11.3013L13.5588 13.1987ZM10.5 11.125H9.5C9.5 11.5554 9.77543 11.9376 10.1838 12.0737L10.5 11.125ZM11.5 6.42087C11.5 5.86858 11.0523 5.42087 10.5 5.42087C9.94771 5.42087 9.5 5.86858 9.5 6.42087H11.5ZM14.1912 11.3013L10.8162 10.1763L10.1838 12.0737L13.5588 13.1987L14.1912 11.3013ZM11.5 11.125V6.42087H9.5V11.125H11.5ZM18.5 10C18.5 14.4183 14.9183 18 10.5 18V20C16.0228 20 20.5 15.5228 20.5 10H18.5ZM10.5 18C6.08172 18 2.5 14.4183 2.5 10H0.5C0.5 15.5228 4.97715 20 10.5 20V18ZM2.5 10C2.5 5.58172 6.08172 2 10.5 2V0C4.97715 0 0.5 4.47715 0.5 10H2.5ZM10.5 2C14.9183 2 18.5 5.58172 18.5 10H20.5C20.5 4.47715 16.0228 0 10.5 0V2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.08f82abed71735dc72a224c9ef71bd8e.svg";
export { ForwardRef as ReactComponent };